module.exports = __webpack_public_path__ + "static/media/substractionButton.d69eb64d.svg";